<template>
    <div class="home">
        <nav-bar></nav-bar>
        <!-- 滚动消息 -->
        <div v-if="!isMobile" class="notification-bar">
            <div class="content-box">
              <div class="notification-content" :style="{ 'animation-duration': duration + 's' }">
                <p v-for="(notification, index) in notifications" :key="index">{{ notification }}</p>
              </div>
            </div>
          </div>
        <!-- bg -->
        <div :class="isMobile ? 'm-header' : 'header'">
          <!-- 滚动消息 -->
          <div v-if="isMobile" class="m-notification-bar">
            <div class="m-content-box">
              <img class="icon" src="../../assets/icon/laba.png" />
              <div class="notification-content" :style="{ 'animation-duration': duration + 's' }">
                <p v-for="(notification, index) in notifications" :key="index">{{ notification }}</p>
              </div>
            </div>
          </div>
          <div class="title_shadow"> Top 100 PoW Cryptocurrencies <p> Learn more about your favorite coins </p></div>
        </div>
        <div class="content">
          <!-- 框类列表 -->
          <div :class="isMobile ? 'm-check-box' : 'check-box'">
            <div :class="item.isCheck ? 'active' : 'check-item'" v-for="(item,index) in list" :key="index" @click="change(item,index)">
              <img v-if="item.url" class="icon" :src="item.url" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <!-- 数据 -->
        <el-card :class="isMobile ? 'm-card' : 'p-card'">
            <el-table :data="tableData" style="width: 100%">
              <template slot="empty">
                <span style="color: #999;">{{ $t('暂无数据') }}</span>
              </template>
              <!-- 矿工 -->
              <el-table-column :label="$t('矿工')">
                <template slot-scope="scope">
                  <span class="user-name">{{ scope.row.Miner }}</span>
                </template>
              </el-table-column>
              <!-- 币种 -->
              <el-table-column v-if="!isMobile" :label="$t('硬币')">
                <template slot-scope="scope">
                  <span class="user-name">{{ scope.row.Coins }}</span>
                </template>
              </el-table-column>
               <!-- 哈希率/效率 -->
               <el-table-column :label="$t('哈希率')">
                <template slot-scope="scope">
                  <span>{{ scope.row.Hashrate }}</span>
                </template>
              </el-table-column>
             <!-- 功耗 -->
             <el-table-column v-if="!isMobile" :label="$t('功耗')">
                <template slot-scope="scope">
                  <span class="doll">$</span>{{ scope.row.Power_Consumption }}
                </template>
              </el-table-column>
              <!-- 单位功率 -->
              <el-table-column :label="$t('单位功率')">
                <template slot-scope="scope">
                  {{ scope.row.Unit_Power }}
                  <!-- <span class="doll">W/G</span> -->
                </template>
              </el-table-column>
              <!-- 生产的PoW（24小时） -->
              <el-table-column v-if="!isMobile" :label="$t('生产（24小时）')">
                <template slot-scope="scope">
                  <span>{{ scope.row.Produced }}</span>
                </template>
              </el-table-column>
              <!-- 收入（24小时） -->
              <el-table-column v-if="!isMobile" :label="$t('收入（24小时）')">
                <template slot-scope="scope">
                  <span class="doll">$</span>{{ scope.row.Revenue }}
                </template>
              </el-table-column>
              <!-- 每日成本（24小时）（0.06美元0）/千瓦时 -->
              <el-table-column v-if="!isMobile" :label="$t('每日成本（24小时）（0.06美元0）/千瓦时')">
                <template slot-scope="scope">
                  <span class="doll">$</span>{{ scope.row.Daily_Cost }}
                </template>
              </el-table-column>
              <!-- 利润（24小时） -->
              <el-table-column v-if="!isMobile" :label="$t('利润（24小时）')">
                <template slot-scope="scope">
                  <span class="doll">$</span>{{ scope.row.Profits }}
                </template>
              </el-table-column>
              <!-- 保本价格 -->
              <el-table-column v-if="!isMobile" :label="$t('保本价格')">
                <template slot-scope="scope">
                  <span class="doll">$</span>{{ scope.row.Breakeven_Price }}
                </template>
              </el-table-column>
              <!-- 日收入 -->
              <el-table-column v-if="!isMobile" :label="$t('日收入')">
                <template slot-scope="scope">
                  <div class="daily">
                    <span class="doll">$</span>{{ scope.row.Daily_Income }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
        </el-card>
        <div class="box-size">
          <div class="pic" v-if="!isMobile">
            <img src="../../assets/img/pic1.png" />
            <span class="title">{{ $t('连接到世界领先的加密货币矿池。') }}</span>
          </div>
          <!-- 比特币介绍 -->
          <div :class="isMobile ? 'mic' : 'pic1'">
            <img src="../../assets/img/pic2.png" />
            <div class="p-left">
              <div class="circle-box">
                <div class="circle c1"></div>
                <div class="circle c2"></div>
                <div class="circle c3"></div>
                <div class="circle c4"></div>
                <div class="circle c5"></div>
                <div class="circle c6"></div>
              </div>
              <span class="title">{{ $t('什么是比特币') }}</span>
              <div class="introduct">
                Bitcoin is a digital currency that is decentralized. Any two people can send each other bitcoins with no involvment of banks or governments. Every transaction of bitcoins is recorded on the public ledger called blockchain. The ledger can be accessed by anyone. There will only ever be 21 million bitcoins and since it's digital it cannot be inflated or manipulated. There is no need to acquire all bitcoins, owning a fraction suffices
              </div>
            </div>
          </div>
          <!-- 云挖矿 -->
          <div :class="isMobile ? 'mic' : 'pic1'">
            <div class="p-left" v-if="!isMobile">
              <div class="circle-box">
                <div class="circle c1"></div>
                <div class="circle c2"></div>
                <div class="circle c3"></div>
                <div class="circle c4"></div>
                <div class="circle c5"></div>
                <div class="circle c6"></div>
              </div>
              <span class="title">{{ $t('云挖矿') }}</span>
              <div class="introduct">
                Mining is the process of creating new cryptocurrencies that are added to the blockchain. Powerful hardware such as ASICs are used to perform complex calculations which then generate bitcoins as a reward. These machines are quite expensive and require technical knowledge and space. provides miners with state of the art hardware powered by over 1.2 MegaWatts of solar power. Currently we have a total of 27,000 Bitcoin mining devices producing 3.78 EH/s. Therefore you can mine conviniently and profitably anywhere with just your device. Our data centers are 87% powered by monocrystalline solar panels increasing our processes' sustainability while decreasing our carbon footprint.               </div>
            </div>
            <img src="../../assets/img/pic3.png" />
            <div class="p-left" v-if="isMobile">
              <div class="circle-box">
                <div class="circle c1"></div>
                <div class="circle c2"></div>
                <div class="circle c3"></div>
                <div class="circle c4"></div>
                <div class="circle c5"></div>
                <div class="circle c6"></div>
              </div>
              <span class="title">{{ $t('云挖矿') }}</span>
              <div class="introduct">
                Mining is the process of creating new cryptocurrencies that are added to the blockchain. Powerful hardware such as ASICs are used to perform complex calculations which then generate bitcoins as a reward. These machines are quite expensive and require technical knowledge and space. provides miners with state of the art hardware powered by over 1.2 MegaWatts of solar power. Currently we have a total of 27,000 Bitcoin mining devices producing 3.78 EH/s. Therefore you can mine conviniently and profitably anywhere with just your device. Our data centers are 87% powered by monocrystalline solar panels increasing our processes' sustainability while decreasing our carbon footprint.               </div>
            </div>
          </div>
        </div>
        <el-dialog :visible.sync="isShow" :width="isMobile ? '100%' : '35%'">
          <div style="width: 100%;">
            <img src="../../assets/img/sb.jpg" style="width: 100%;height: 100%;" />
          </div>
        </el-dialog>
        <footers></footers>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { allList, listData, notice, info } from '../../api/index'
export default {
  data () {
    return {
      isShow: true,
      notifications: ['Dear user, if you do not receive a response for a long time when contacting customer service, please change the customer service channel in time to solve the problem for you.'], // 通知数组
      duration: 30, // 每条通知停留时间（秒）
      checkIndex: 0,
      list: [
        {
          label: 'All',
          icon: '',
          isCheck: true
        },
        {
          label: 'ALPH',
          icon: require('../../assets/icon/b1.png'),
          isCheck: false
        },
        {
          label: 'BTC',
          icon: require('../../assets/icon/b2.png'),
          isCheck: false
        },
        {
          label: 'SPACE',
          icon: require('../../assets/icon/b3.png'),
          isCheck: false
        },
        {
          label: 'LTC',
          icon: require('../../assets/icon/b4.png'),
          isCheck: false
        },
        {
          label: 'KAS',
          icon: require('../../assets/icon/b5.png'),
          isCheck: false
        },
        {
          label: 'ETC',
          icon: require('../../assets/icon/b6.png'),
          isCheck: false
        },
        {
          label: 'ETHW',
          icon: require('../../assets/icon/b7.png'),
          isCheck: false
        },
        {
          label: 'BCH',
          icon: require('../../assets/icon/b2.png'),
          isCheck: false
        },
        {
          label: 'DNX',
          icon: require('../../assets/icon/b8.png'),
          isCheck: false
        },
        {
          label: 'IRON',
          icon: require('../../assets/icon/b9.png'),
          isCheck: false
        },
        {
          label: 'LCT',
          icon: require('../../assets/icon/b4.png'),
          isCheck: false
        },
        {
          label: 'RVN',
          icon: require('../../assets/icon/b10.png'),
          isCheck: false
        }
      ],
      tableData: [],
      nic: ''
    }
  },
  computed: {
    // 映射 Vuex 的 getter 判断当前登录端
    ...mapGetters("device", ["isMobile"]),
  },
  created () {
    this.getAllList()
    this.getNotice()
    if (localStorage.getItem('token')) {
      this.getInfo()
    }
  },
  methods: {
    // 获取全部列表
    getAllList() {
      allList().then(res=> {
        if (res.code == 0) {
          var result = res.data.cate
          result.map(i=> {
            i.isCheck = false
          })
          result.unshift({
            url: '',
            name: "ALL",
            id: 0,
            isCheck: true
          })
          this.list = result

          this.tableData = res.data.list
        }
      })
    },
    getNotice() {
      notice().then(res=> {
        if (res.code == 0) {
          this.notifications.push(res.data)
        }
      })
    },
    getList(id) {
      listData({id:id}).then(res=> {
        if (res.code == 0) {
          this.tableData = res.data
        }
      })
    },
    // 切换Type请求
    change(t,i) {
      this.tableData = []
      this.list.forEach((item, index)=> {
        if (t.id == item.id) {
          item.isCheck = true
          if (item.id ==0) {
            this.getAllList()
          }else {
            this.getList(item.id)
          }

        } else {
          item.isCheck = false
        }
      })
    },
    getInfo() {
      info().then(res=> {
        if(res.code == 0) {
          localStorage.setItem('info', JSON.stringify(res.data.info))
        }
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.home {

  .notification-bar {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: rgba(42,55,174,.8);
  }

  .m-notification-bar {
    width: 100%;
    height: 40px;
    line-height: 40px;
    // background: rgba(42,55,174,.8);
    position: absolute;
    top: 0;
  }

  .m-content-box {
    width: 80%;
    margin: 0 auto;
    position: relative;
    overflow-x: hidden;

    .notification-content {
      color: #fff;
      font-weight: 600;
      position: absolute;
      top: 0;
      left: 40px;
      white-space: nowrap;
      animation-name: scroll;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-delay: 2s;
    }

    .notification-content p {
      display: inline;
      padding: 0 20px;
      margin: 0;
    }

    @keyframes scroll {
      from {
        transform: translate3d(100%, 0, 0);
      }
      to {
        transform: translate3d(-100%, 0, 0);
      }
    }
  }

  .content-box {
    width: 58%;
    height: 40px;
    margin: 0 auto;
    position: relative;
    overflow-x: hidden;
  }
  .notification-content {
    color: #f8e71c;
    font-weight: 600;
    position: absolute;
    white-space: nowrap;
    animation-name: scroll;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-delay: 2s;
  }

  .notification-content p {
    display: inline;
    padding: 0 5px;
    margin: 0;
  }

  @keyframes scroll {
    from {
      transform: translate3d(100%, 0, 0);
    }
    to {
      transform: translate3d(-100%, 0, 0);
    }
  }

  .header {
    align-items: center;
    background: url('../../assets/img/bg.jpg') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    min-height: 400px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    color: #fff;
    position: relative;

    .title {
      font-size: 45px;
      font-weight: 800;
      width: 42%;

      p {
        font-weight: 600;
        font-size: 36px;


      }
    }
  }
  .title_shadow{
    color: #7e5678;
    font-weight: 700;
    text-shadow:
        0 0 5px #fff,  /* 内层发光 */
        0 0 10px #fff, /* 中间发光 */
        0 0 15px #fff, /* 外层发光 */
        0 0 20px #fff, /* 可以加彩色光晕 */
        0 0 30px #fff,
        0 0 40px #fff;
  }

  .content {
    display: flex;
    justify-content: center;
    padding: 40px 0;

    .check-box {
      width: 72%;
      display: flex;
      flex-wrap: wrap;

      .check-item, .active {
        align-items: center;
        background: #f6f6f6;
        border-radius: 48px;
        box-shadow: 0 7px 29px 0 rgba(99, 99, 110, .2);
        display: flex;
        font-size: 14px;
        height: 48px;
        justify-content: center;
        margin-bottom: 15px;
        margin-right: 15px;
        width: 120px;
        cursor: pointer;
        .icon {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }

      .active {
        background-color: #61c7ed;
        color: #fff;
      }
    }
  }

  :deep(.has-gutter) {
    .cell {
      font-size: 12px;
      color: #8fa6bf;
    }
  }

  .p-card {
    width: 72%;
    margin: 20px auto;

    .doll {
      color: #8fa6bf;
      margin-right: 4px;
    }

    .daily {
      background-color: #67c23a;
      border-color: #67c23a;
      color: #fff;
      text-align: right;
      padding: 5px 10px;
      border-radius: 3px;

      .doll {
        color: #fff;
        margin-right: 4px;
      }
    }
  }

  .box-size {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 0;
    margin-top: 20px;
    // margin-bottom: 10px;

    .pic {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 1080px;
      }

      .title {
        font-size: 45px;
        font-weight: 800;
        margin-top: 40px;
      }
    }

    .pic1 {
      width: 55%;
      margin: 0 auto;
      display: flex;
      align-items: center;


      img {
        width: 500px;
        margin-right: 100px;
      }

      .p-left {
        display: flex;
        flex-direction: column;

        .title {
          font-size: 30px;
          font-weight: 800;
          padding: 20px 0;
        }

        .introduct {
          width: 75%;
          font-size: 18px;
          line-height: 36px;
          color: #666;
        }

        .circle-box {
          display: flex;
          align-items: center;

          .circle {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            margin-right: 5px;
          }

          .c1 {
            background: #b63036;
          }
          .c2 {
            background: #ffeb2b;
          }
          .c3 {
            background: #7fff00;
          }
          .c4 {
            background: #74daff;
          }
          .c5 {
            background: #b63036;
          }
          .c6 {
            background: #fa49ff;
          }
        }
      }
    }

    .mic {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px 20px;

      img {
        width: 100%;
        height: 300px;
      }

      .p-left {
        display: flex;
        flex-direction: column;
        margin: 20px 0;

        .title {
          font-size: 16px;
          font-weight: 600;
          padding: 20px 0;
        }

        .introduct {
          font-size: 12px;
          line-height: 24px;
          color: #666;
        }

        .circle-box {
          display: flex;
          align-items: center;

          .circle {
            width: 15px;
            height: 15px;
            border-radius: 50%;
            margin-right: 5px;
          }

          .c1 {
            background: #b63036;
          }
          .c2 {
            background: #ffeb2b;
          }
          .c3 {
            background: #7fff00;
          }
          .c4 {
            background: #74daff;
          }
          .c5 {
            background: #b63036;
          }
          .c6 {
            background: #fa49ff;
          }
        }
      }
    }
  }

  // 移动端
  .m-header {
    position: relative;
    align-items: center;
    background: url('../../assets/img/bg.jpg') no-repeat;
    background-size: cover;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    height: 180px;
    justify-content: center;
    // padding: 13.333vw 2.667vw;
    width: 100%;
  }

  .m-card {
    width: 96%;
    padding-top: 30px;
    padding-bottom: 70px;
    font-size: 12px;
    margin: 20px auto;
    border-radius: 18px;

    :deep(.has-gutter) {
    .cell {
      font-size: 12px;
      color: #8fa6bf;
    }
  }

    .user-name {
      font-size: 12px;
    }
    :deep(.cell) {
      font-size: 12px;
    }
    .table-price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .m-check-box {
      // width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 10px;

      .check-item, .active {
        align-items: center;
        background: #f6f6f6;
        border-radius: 48px;
        box-shadow: 0 7px 29px 0 rgba(99, 99, 110, .2);
        display: flex;
        font-size: 12px;
        padding: 5px 10px;
        justify-content: center;
        margin-bottom: 15px;
        width: 20%;
        cursor: pointer;
        .icon {
          width: 20px;
          height: 20px;
        }
      }

      .active {
        background-color: #61c7ed;
        color: #fff;
      }
  }

  :deep(.el-dialog) {
    background: rgba(0,0,0,.5);
  }

  :deep(.el-dialog__close) {
    font-weight: 700;
    color: #fff;
  }
}
</style>
